import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'

export const SingleStatusButton = styled.svg((props) => {
  const { marginLeft } = props
  return `
    overflow: visible !important;
    ${stylesIf(marginLeft, `margin-left: ${marginLeft};`)}
  `
})

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const StyledFeatureStatus = styled.div`
  align-self: flex-start;
  flex-grow: 9;
`

export const ParameterStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${({ isEditing }) => isEditing && 'margin-top: 20px;'}
`
